import { PropsWithChildren } from 'react'

type InlineProps = {}

export const Inline = ({ children }: PropsWithChildren<InlineProps>) => {
  return <div className="flex flex-row gap-12">{children}</div>
}
